module.exports = __webpack_public_path__ + "static/media/connect-facebook-catalog-banner.7d6ce99e.jpg";